export default __webpack_public_path__ + "static/media/Button_Close.1efe2844.png";